import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { PRICE } from '../lib/config';
export function Guarantee() {
  return <section className="w-full bg-ivory py-16 sm:py-24" data-id="element-160" data-mp="1o2vhap4uen6k">
      <div className="mx-auto max-w-3xl px-5" data-id="element-161" data-mp="223685s65k1rq">
        <div className="border border-gold-soft bg-white px-7 py-12 text-center shadow-card sm:px-12" data-id="element-162" data-mp="222wik5p0rwmk">
          <span className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-gold-tint" data-id="element-163" data-mp="1x54qnbodkaid">
            <ShieldCheckIcon className="h-7 w-7 text-gold-dark" aria-hidden="true" data-id="element-164" data-mp="19f0qjeaeasw4" />
          </span>

          <h2 className="mt-7 font-serif text-3xl sm:text-4xl text-ink" data-id="element-165" data-mp="14dl1zc90e48z">
            The 12-Minute Formals Guarantee — 30 days, no questions asked
          </h2>
          <div className="rule-gold mx-auto mt-7 w-24" aria-hidden="true" data-id="element-166" data-mp="1ecsp2r5jpd9a" />

          <p className="mt-7 font-serif text-xl italic leading-snug text-gold-dark" data-id="element-167" data-mp="qnpygtsxoa2n">
            Download it. Print the shot lists. Run the 12-Minute Formals Method at your next
            wedding.
          </p>
          <p className="mx-auto mt-5 max-w-xl text-base leading-relaxed text-ink-soft" data-id="element-168" data-mp="p0b7vx1bzcgh">
            If it doesn&rsquo;t buy you back at least 20 minutes of the day — or if within
            30 days it&rsquo;s simply not what you expected — reply to your receipt and
            I&rsquo;ll refund the {PRICE}. No forms, no hoops, no hard feelings.
          </p>
        </div>
      </div>
    </section>;
}